import { render, staticRenderFns } from "./BrightStoreTopTen.vue?vue&type=template&id=2851ab2b"
import script from "./BrightStoreTopTen.vue?vue&type=script&lang=js"
export * from "./BrightStoreTopTen.vue?vue&type=script&lang=js"
import style0 from "./BrightStoreTopTen.vue?vue&type=style&index=0&id=2851ab2b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports